import { RoomSelectFields } from "../../../../api/graphql/rooms/rooms";

export const structureOptions = (
  data: RoomSelectFields[] | undefined,
  currentRoom: string
) => {
  if (data === undefined) {
    return [];
  }

  const collator = new Intl.Collator(undefined, {
    sensitivity: "base",
    numeric: true,
  });

  const filteredData = data
    .filter((item) => item.id !== currentRoom)
    .sort((a, b) => collator.compare(a.name, b.name));

  return filteredData.map((item) => ({
    value: item.id,
    label: item.name,
  }));
};
